import React from "react";
import { Construction } from "lucide-react";

export default function ComingSoon({ title, blurb }) {
  return (
    <div className="dnya-reveal" style={{ maxWidth: 600, margin: "60px auto 0", textAlign: "center", padding: 30, background: "var(--dnya-card)", border: `1px dashed var(--dnya-mosaic-1)`, borderRadius: 16 }}>
      <div style={{ width: 70, height: 70, borderRadius: "50%", background: "var(--dnya-mosaic-1)", color: "var(--dnya-high-1)", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 14 }}>
        <Construction size={28} />
      </div>
      <h1 className="font-dnya" style={{ fontSize: 26, color: "var(--dnya-high-1)", margin: 0 }}>{title}</h1>
      <p style={{ color: "var(--dnya-high-2)", fontSize: 14, marginTop: 10, lineHeight: 1.6 }}>{blurb}</p>
      <div style={{ marginTop: 18, color: "var(--dnya-text-muted)", fontSize: 12, fontStyle: "italic" }}>Insha&apos;Allah, coming soon in the next iteration.</div>
    </div>
  );
}
